/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CurrencyExchangeConfigurationDefinition extends models.CurrencyExchangeConfigurationComponentBase {
    getFixupPrototypeFunction() { return CurrencyExchangeConfigurationDefinition.fixupPrototype; }

    static newInstance(model: Partial<CurrencyExchangeConfigurationDefinition>): CurrencyExchangeConfigurationDefinition {
        let obj = Object.assign(new CurrencyExchangeConfigurationDefinition(), model);
        CurrencyExchangeConfigurationDefinition.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CurrencyExchangeConfigurationDefinition>): CurrencyExchangeConfigurationDefinition {
        if (!model) return null;
        return CurrencyExchangeConfigurationDefinition.newInstance(<CurrencyExchangeConfigurationDefinition> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CurrencyExchangeConfigurationDefinition) {
        if (!obj) return;

        models.CurrencyExchangeConfigurationDefinition.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CurrencyExchangeConfigurationDefinition): boolean {
        if (models.CurrencyExchangeConfigurationComponentBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CurrencyExchangeConfigurationDefinition.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.configurations) {
            for (let val of this.configurations) {
                models.CurrencyRateConfiguration.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of Currency Exchange Configuration
     */
    name: string;

    /**
     * Description of Currency Exchange Configuration
     */
    description: string;

    /**
     * Configured Currency Exchange Configuration
     */
    configurations: Array<models.CurrencyRateConfiguration>;

    /**
     * Conversion type of currency exchange configuration.
     */
    conversion_type: models.CurrencyConversionType;

    /**
     * Target Currency for Exchange Configuration
     */
    target_currency: models.Currency;

    /**
     * Is currency exchange enabled
     */
    is_enabled: boolean;

    /**
     * Scope of currency exchange configuration.
     */
    scope: models.CurrencyConversionScope;

}
